export enum SporsmalsType {
  Envalg = "ENVALG",
  Flervalg = "FLERVALG",
}
